import { identity, result } from 'underscore';
import { getBulkApiErrors } from '@bingads-webui-campaign/api-errors';
import { ResponsiveAd } from '@bingads-webui/campaign-odata-schemas';
import { MMAAssetConfigs } from '../config';

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

const bulkUpsertAdSettingsEntityErrorMap = {
  [getBulkUploadErrorType(ResponsiveAd)]: 'ResponsiveAd',
};

export const mapBulkUpsertErrors = ({
  errors,
  bulkUpsertEntityErrorMap = bulkUpsertAdSettingsEntityErrorMap,
  errorProcessor = identity,
  scenario,
  i18n,
  activityLogger,
}) =>
  getBulkApiErrors(errors, scenario, i18n, activityLogger).map((error) => {
    const errorType = error.type;
    const mappedErrorType = result(bulkUpsertEntityErrorMap, errorType, errorType);
    // eslint-disable-next-line no-param-reassign
    error.type = mappedErrorType;
    return errorProcessor(error);
  });

export const errorMapper = (error, i18n) => {
  if ((error && error.message && error.message.indexOf('<a href=') !== -1) || (error && error.isHtmlMessage)) {
    return {
      ...error,
      DangerousHtmlMessage: error.message,
    };
  }

  if (error.property === 'CallToAction') {
    return i18n.getString(`Error_Campaign_API_${error.code}`);
  }

  if (error.property === 'ResponsiveAdHeadlines') {
    return i18n.getString(`Multimedia_Ad_Error_${error.code}`, {
      field: 'short headline',
      min_count: MMAAssetConfigs.MIN_HEADLINES,
    }) || error.message;
  }

  if (error.property === 'ResponsiveAdLongHeadlines') {
    return i18n.getString(`Multimedia_Ad_Error_${error.code}`, {
      field: 'long headline',
      min_count: MMAAssetConfigs.MIN_LONGHEADLINES,
    }) || error.message;
  }

  if (error.property === 'ResponsiveAdDescriptions') {
    return i18n.getString(`Multimedia_Ad_Error_${error.code}`, {
      field: 'ad text',
      min_count: MMAAssetConfigs.MIN_DESCRIPTIONS,
    }) || error.message;
  }

  if (error.property === 'BusinessName') {
    return i18n.getString(`Multimedia_Ad_Error_${error.code}`);
  }

  if (error.property === 'CustomParameters' || (error.code && error.code.toLowerCase().indexOf('customparameters') !== -1)) {
    return i18n.getString(`Error_Campaign_API_${error.code}`);
  }

  return i18n.getString(`Multimedia_Ad_Error_${error.code}`)
    || error.message
    || i18n.getString('ErrorNumber_-1');
};
